import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../material-icon/material-icon";
import styles from "./arrow-icons-button.module.scss";

interface IProps {
  text: string;
  onClick: () => void;
  onLeftIconClick: () => void;
  onRightIconClick: () => void;
  showArrowIcon?: boolean;
}

const ArrowIconsButton = (props: IProps) => {
  const {
    text,
    onClick,
    onLeftIconClick,
    onRightIconClick,
    showArrowIcon = true,
    ...rest
  } = props;

  return (
    <button
      {...{
        ...rest,
        className: `text-decoration-none border border-1 text-muted ${styles.button} px-3`,
      }}
    >
      <Row className="justify-content-center align-items-center g-2">
        {showArrowIcon && (
          <Col className="col-auto">
            <MaterialIcon
              size={18}
              icon="chevron_left"
              color="#69768B"
              className="justify-content-center"
              weight={600}
              onClick={onLeftIconClick}
            />
          </Col>
        )}
        <Col className="col-auto font-weight-500" onClick={onClick}>
          {text}
        </Col>
        {showArrowIcon && (
          <Col className="col-auto">
            <MaterialIcon
              size={18}
              icon="chevron_right"
              color="#69768B"
              className="justify-content-center"
              weight={600}
              onClick={onRightIconClick}
            />
          </Col>
        )}
      </Row>
    </button>
  );
};

export default ArrowIconsButton;
